/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinkcodelabel3Inputs */

const en_profilelinkcodelabel3 = /** @type {(inputs: Profilelinkcodelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code from the app`)
};

const de_profilelinkcodelabel3 = /** @type {(inputs: Profilelinkcodelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code aus der App`)
};

/**
* | output |
* | --- |
* | "Code from the app" |
*
* @param {Profilelinkcodelabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinkcodelabel3 = /** @type {((inputs?: Profilelinkcodelabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinkcodelabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinkcodelabel3(inputs)
	return de_profilelinkcodelabel3(inputs)
});
export { profilelinkcodelabel3 as "profileLinkCodeLabel" }